import { Deal } from "@/types/deal";

export function coversPerDayFromUnderwriting(deal: Deal, yearIdx: number) {
  const fnbData = deal.kpis?.fnb;
  const roomsSoldPerDay = roomsSoldPerDayFromUnderwriting(deal, yearIdx);
  const guestsPerRoom = fnbData?.avgGuests ?? 1.5;
  const guestsInHousePerDay = roomsSoldPerDay * guestsPerRoom;
  const result: Record<string, number> = {};

  (["breakfast", "lunch", "dinner", "bar"] as const).forEach((k) => {
    const capturePct = (fnbData?.capture?.[k] ?? 0) / 100;
    const external = fnbData?.external?.perDay?.[k] ?? 0;
    result[k] = Math.max(
      0,
      Math.round(guestsInHousePerDay * capturePct + external)
    );
  });

  return result;
}

/**
 * Получает данные о SPA из 'deal'.
 */
export function spaTreatmentsFromUnderwriting(deal: Deal) {
  const spaInputs = deal.kpis?.otherRev?.spa;
  const spaAssumps = deal.kpis?.assumptions?.staffingAssumptions;

  return {
    treatmentsPerDay: spaInputs?.treatmentsPerDay ?? 0,

    openHours: spaAssumps?.spaHours ?? 10,
  };
}

/**
 * Получает кол-во проданных комнат в день из 'deal'.
 */
export function roomsSoldPerDayFromUnderwriting(
  deal: Deal,
  yearIdx: number
): number {
  // TODO: Логика по годам (yearIdx) здесь все еще не реализована
  const roomsSold = deal.kpis?.roomRevenue?.totals?.roomsSold ?? 0;
  return roomsSold / 365;
}
